import { render, staticRenderFns } from "./appSwiperItem.vue?vue&type=template&id=3c30deb5&"
import script from "./appSwiperItem.vue?vue&type=script&lang=js&"
export * from "./appSwiperItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports